import { mockLoginResponse } from '@/data/mockData.js';

export default {
    namespaced: true,
    state:{
        name: localStorage.getItem('name'),
        email: localStorage.getItem('email'),
        image: localStorage.getItem('image_url'),
        settings: JSON.parse(localStorage.getItem('settings') || '{}'),
        loginAttempts: 0,
        lastAttemptTime: null
    },
    mutations: {
        createAutentication(state, payload){
            localStorage.setItem('token', payload.token);

            if(payload.isSave) localStorage.setItem('isSave', true);
            
            // Reset login attempts on successful login
            state.loginAttempts = 0;
            state.lastAttemptTime = null;
        },
        logOut(state){
            localStorage.removeItem('isSave');
            localStorage.removeItem('token');
            localStorage.removeItem('name');
            localStorage.removeItem('email');
            localStorage.removeItem('image_url');
            localStorage.removeItem('settings');

            state.name = null;
            state.email = null;
            state.image = null;
            state.settings = {};
        },
        incrementLoginAttempts(state) {
            state.loginAttempts++;
            state.lastAttemptTime = Date.now();
        },
        resetLoginAttempts(state) {
            state.loginAttempts = 0;
            state.lastAttemptTime = null;
        }
    },
    getters: {
        isRateLimited: (state) => {
            if (state.loginAttempts >= 3) {
                const timeSinceLastAttempt = Date.now() - state.lastAttemptTime;
                const waitTime = 30000; // 30 seconds
                return timeSinceLastAttempt < waitTime;
            }
            return false;
        },
        timeUntilNextAttempt: (state) => {
            if (state.loginAttempts >= 3) {
                const timeSinceLastAttempt = Date.now() - state.lastAttemptTime;
                const waitTime = 30000; // 30 seconds
                const remaining = waitTime - timeSinceLastAttempt;
                return remaining > 0 ? Math.ceil(remaining / 1000) : 0;
            }
            return 0;
        }
    },
    actions: {
        async autheticate({ state, commit, getters }, user){
            // Check rate limiting
            // if (getters.isRateLimited) {
            //     const secondsLeft = getters.timeUntilNextAttempt;
            //     return {
            //         status: 'error',
            //         message: `Muitas tentativas de login. Aguarde ${secondsLeft} segundos antes de tentar novamente.`,
            //         data: null
            //     };
            // }

            // Simular delay da API
            await new Promise(resolve => setTimeout(resolve, 800));
            
            // Validate credentials (mock validation)
            const validCredentials = mockLoginResponse.data.email === user.email && 
                                   user.password === 'filesave123';
            
            if(mockLoginResponse.status !== 'success' || !validCredentials){
                commit('incrementLoginAttempts');
                
                // Specific error messages
                if (user.email !== mockLoginResponse.data.email) {
                    return {
                        status: 'error',
                        message: 'E-mail não encontrado em nossa base de dados.',
                        data: null
                    };
                } else if (user.password !== 'filesave123') {
                    return {
                        status: 'error',
                        message: 'Senha incorreta. Verifique suas credenciais.',
                        data: null
                    };
                }
                
                return {
                    status: 'error',
                    message: 'Credenciais inválidas.',
                    data: null
                };
            }

            state.name = mockLoginResponse.data.name;
            state.email = mockLoginResponse.data.email;
            state.image = mockLoginResponse.data.image_url;
            state.settings = mockLoginResponse.data.settings;

            localStorage.setItem('name', mockLoginResponse.data.name);
            localStorage.setItem('email', mockLoginResponse.data.email);
            localStorage.setItem('image_url', mockLoginResponse.data.image_url);
            localStorage.setItem('settings', JSON.stringify(mockLoginResponse.data.settings));

            commit('createAutentication', {
                token: mockLoginResponse.data.token,
                isSave: user.isSave
            });

            return {
                status: 'success',
                message: 'Login realizado com sucesso!',
                data: mockLoginResponse.data
            };
        },

        async register({ state, commit, getters }, userData){
            // Check rate limiting
            if (getters.isRateLimited) {
                const secondsLeft = getters.timeUntilNextAttempt;
                return {
                    status: 'error',
                    message: `Muitas tentativas de registro. Aguarde ${secondsLeft} segundos antes de tentar novamente.`,
                    data: null
                };
            }

            // Simular delay da API
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            // Simulate email already exists check
            if (userData.email === mockLoginResponse.data.email) {
                commit('incrementLoginAttempts');
                return {
                    status: 'error',
                    message: 'Este e-mail já está cadastrado em nossa base de dados.',
                    data: null
                };
            }
            
            // Create new user data (mock)
            const newUserData = {
                token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyIwIjoibmV3dXNlciIsImV4cCI6MTc1NzM3NjMyNX0.NewUserTokenHash",
                name: userData.name,
                email: userData.email,
                image_url: "https://ui-avatars.com/api/?name=" + encodeURIComponent(userData.name) + "&background=3b82f6&color=fff&size=128"
            };

            // Update state with new user data
            state.name = newUserData.name;
            state.email = newUserData.email;
            state.image = newUserData.image_url;

            localStorage.setItem('name', newUserData.name);
            localStorage.setItem('email', newUserData.email);
            localStorage.setItem('image_url', newUserData.image_url);

            commit('createAutentication', {
                token: newUserData.token,
                isSave: false
            });

            return {
                status: 'success',
                message: 'Conta criada com sucesso!',
                data: newUserData
            };
        }
    }
}